var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-infinite-scroll"},[(_vm.loading)?_vm._t("default",function(){return [_c('bunt-progress-circular',{attrs:{"size":"huge","page":true}})]}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }